import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { IUser } from '../../shared/typings/interfaces/user.interface';
import * as currentUserActions from '../actions/current-user-actions';
import { ApiService } from './../../shared/services/api-service/api-service';

interface IAction {
  type: string;
  payload: IUser;
}

@Injectable()
export class CurrentUserEffects {
  constructor(private actions$: Actions, private apiService: ApiService, private store$: Store<any>) {}

  @Effect()
  loadCurrentUser$ = this.actions$.pipe(
    ofType(currentUserActions.LOAD_CURRENT_USER),
    switchMap((action: IAction) => {
      const { _id } = action.payload;
      return this.apiService.getUser(_id).pipe(
        mergeMap((user: IUser) => {
          return [new currentUserActions.LoadCurrentUserSuccess(user)];
        }),
        catchError(error => {
          return of(new currentUserActions.LoadCurrentUserFail(error));
        }),
      );
    }),
  );
}
